module.exports = __webpack_public_path__ + "static/media/Vera-Gold--ED.be3b78b5.jpg";